export default __webpack_public_path__ + "static/media/bulb.4f994f2c.svg";